import { SalariesRecentSubmission } from 'modules/salaries/types/SalariesRecentSubmission';
import { getJson } from 'utils/http/getJson';

export async function salariesFetchRecentSubmissions(): Promise<
  SalariesRecentSubmission[]
> {
  const { recentSubmissions } = await getJson<{
    recentSubmissions: SalariesRecentSubmission[];
  }>('/data/salary-surveys/recent-submissions');

  return recentSubmissions;
}
